module.exports = __webpack_public_path__ + "media/question3_au.eba6c85c.mp3";